import { render } from "./OrderStatus.vue?vue&type=template&id=55c8900a"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"
script.render = render

export default script